const cache = {}
export default function getProductJSON(slug = window.location.pathname.split('/').reverse()[0], opts = {}) {
    const { product } = JSON.parse(
        document.querySelector('.js-productJSON').innerHTML
    )

    return product
}
